export function toggleToursView() {
  this.setState({ isGrid: !this.state.isGrid });
}
